/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React from "react";
import ScrubberMidDivCss from "./ScrubberMidDiv.css";
import * as constants from "constants/constants";
import { getTotalPages } from "selectors/documentSelectors";
import { getAdressBarHeight } from "selectors/appUiStateSelectors";
import * as stores from "stores";

class ScrubberMidDiv extends React.Component {
  constructor(props) {
    super(props);
    this.totalPages = getTotalPages(stores);
    this.addressBarHeight = getAdressBarHeight(stores);
    this.separatorText = props.intl.formatMessage({ id: "scrubber.pagenumber.display.separator" });
  }

  render() {
    let className = ScrubberMidDivCss.scrubberMidDiv;
    if (!this.props.show) {
      className += ` ${ScrubberMidDivCss.hideScrubberMidDiv}`;
    }

    let scrubberMidDivStyle = {
      top: `calc(50% - ${(constants.SCRUBBER_PAGE_NUM_INDICATOR_HEIGHT + this.addressBarHeight) / 2}px)`
    };

    return (
      <div className={className} style={scrubberMidDivStyle}>
        <div className={ScrubberMidDivCss.scrubberMidDivCurrentPageNum}>{this.props.pageNumber}</div>
        <hr className={ScrubberMidDivCss.scrubberHRStyle} />
        <div className={ScrubberMidDivCss.scrubberTotPageNum}>{`${this.separatorText} ${this.totalPages}`}</div>
      </div>
    );
  }
}

export { ScrubberMidDiv };
